import { createContext, useCallback, useContext } from 'react';
import { isFeatureEnabled } from '@vp/ab-reader';
import '../types/FeatureFlag';
import type { FeatureFlag, FeatureFlagName } from '../types/FeatureFlag';

const FeatureFlagContext = createContext<FeatureFlag[]>([]);

export const FeatureFlagProvider = FeatureFlagContext.Provider;
export const FeatureFlagConsumer = FeatureFlagContext.Consumer;

export function useIsFeatureFlagActive(
    featureFlagName: FeatureFlagName
): () => boolean | undefined {
    const featureFlags: FeatureFlag[] = useContext(FeatureFlagContext);
    return useCallback(() => {
        const featureFlag = featureFlags?.find((ff) => ff.featureName === featureFlagName);
        if (!featureFlag) {
            console.warn(`Feature flag with key ${featureFlagName} not found`);
            return;
        }

        if (typeof window !== 'undefined') {
            isFeatureEnabled(featureFlag.featureName);
        }

        return featureFlag.enabled;
    }, [featureFlags, featureFlagName]);
}
